import { Bean, BindingCreator, ValidationRules } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../../translations';

const t = patientMedicalInformationTranslationKeys.chronicDisease.form.create;

const MAX_REASON_CONTENT_LENGTH = 200;
const REMOVAL_REASON_FIELD_NAME = 'removalReason';
const VALIDATION_RULES: ValidationRules<Bean> = { required: true, maxLength: MAX_REASON_CONTENT_LENGTH };

type RemovalReasonType = string | null;

export type RemovalReasonFormBeanPart = { [REMOVAL_REASON_FIELD_NAME]: RemovalReasonType };

type RemovalReasonProps = {
   readonly register: BindingCreator<RemovalReasonFormBeanPart>;
};

export const RemovalReason = (props: RemovalReasonProps): JSX.Element => {
   return (
      <Textarea
         controller={props.register(REMOVAL_REASON_FIELD_NAME, VALIDATION_RULES)}
         rows={3}
         maxRows={3}
         maxLength={MAX_REASON_CONTENT_LENGTH}
         label={t.removalReason.label}
         placeholder={t.removalReason.placeholder}
         testId={REMOVAL_REASON_FIELD_NAME}
      />
   );
};
